// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"ced292b4","33":"4cd801e4","571":"c5de795a","584":"5335ad0c","625":"de486df6","706":"95358da9","764":"67c72b0d","812":"5a59cd21","851":"912b2f78","922":"bc33227e"}[chunkId] + ".chunk.js";
};